// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-markdown-page-js": () => import("./../../../src/components/markdownPage.js" /* webpackChunkName: "component---src-components-markdown-page-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-gdc-js": () => import("./../../../src/pages/gdc.js" /* webpackChunkName: "component---src-pages-gdc-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

